import {getEnv} from "@/utilities/env";

export function loadBookingCalendar() {

    if(!document.querySelector('script#nf-booking-calendar')) {
        const s = document.createElement('script');
        s.src= getEnv('VITE_BOOKING_CALENDAR_URL');
        s.async = true;
        s.defer = true;
        s.id = 'nf-booking-calendar';
        document.head.appendChild(s);
    }
}